import {confirmEmail, resetPassword, login, forgottenPassword} from '../models/Util';
import {register, logout} from '../models/User';

const loginAction = (caller, payload) => {
    return {
        type: "LOGIN",
        payload: login(caller, payload)
    }
};

const registerAction = (caller, payload) => {
    return {
        type: "REGISTER",
        payload: register(caller, payload)
    }
};

const logoutAction = (caller) => {
    return {
        type: "LOGOUT",
        payload: logout(caller, logoutAction)
    }
};

const forgottenPasswordAction = (caller, payload) => {
    return {
        type: "FORGOT_PASSWORD",
        payload: forgottenPassword(caller, payload)
    }
};

const resetPasswordAction = (caller, paylaod) => {
    return {
        type: "RESET_PASSWORD",
        payload: resetPassword(caller, paylaod)
    }
};

const confirmEmaildAction = (caller, paylaod) => {
    return {
        type: "CONFIRM_EMAIL",
        payload: confirmEmail(caller, paylaod)
    }
};

export {loginAction, registerAction, logoutAction, forgottenPasswordAction, resetPasswordAction, confirmEmaildAction};


// WEBPACK FOOTER //
// ./src/actions/Auth.js